/**
 * Created by methee on 9/11/17.
 */
/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key, css-modules/no-unused-class, react/forbid-prop-types
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import moment from 'moment';
import cx from 'classnames';

import HotelType from '../../data/types/HotelType';
import UserType from '../../data/types/UserType';
// import mp from '../../analytic';
import history from '../../history';

import CurrencyDisplay from '../../components/CurrencyDisplay';
import TruncatableText from '../../components/TruncatableText';
import CDNImage from '../../components/CDNImage';
import Leaflet from '../../components/LeafletMap';
import NearbyMenus from './NearbyMenus';
import Nearby from './Nearby';
import BookingEngine from './BookingEngine';
import HotelImagesGallery from './HotelImagesGallery';
import HotelNameOverlay from './HotelNameOverlay';
import BreadCrumb from './BreadCrumb';

import s from './Hotel.css';
import wifi from './wifi.webp';
import wifiAdd2x from './wifi@2x.webp';
import parking from './parking.webp';
import parkingAdd2x from './parking@2x.webp';
import water from './bottle-of-water.webp';
import waterAdd2x from './bottle-of-water@2x.webp';
import iconPin from './icon-pin.webp';
import iconPinAdd2x from './icon-pin@2x.webp';
import iconPhone from './icon-phone.webp';
import iconPhoneAdd2x from './icon-phone@2x.webp';

import hairDryer from './hair-dryer.svg';
import hairBrush from './hair-brush.svg';
import shavingKit from './shaving-kit.svg';
import googleChromecast from './google-chromecast.svg';
import LeafletMobile from '../../components/LeafletMap/LeafletMobile';

const maximumMobileWidth = 992;

// let tagClouds = [];
// let CloudElem = null;
const featureImages = {
  wifi: {
    normal: wifi,
    add2x: wifiAdd2x,
  },
  parking: {
    normal: parking,
    add2x: parkingAdd2x,
  },
  'bottle-of-water': {
    normal: water,
    add2x: waterAdd2x,
  },
  'hair-dryer': {
    normal: hairDryer,
    add2x: hairDryer,
  },
  'hair-brush': {
    normal: hairBrush,
    add2x: hairBrush,
  },
  'shaving-kit': {
    normal: shavingKit,
    add2x: shavingKit,
  },
  'google-chromecast': {
    normal: googleChromecast,
    add2x: googleChromecast,
  },
};

const messages = defineMessages({
  perNight: {
    id: 'hotel.per_night',
    defaultMessage: '##{price} / Night##',
    description:
      'Label showing price per night. Do not translate or remove the {price} path',
  },
  numberOfReviews: {
    id: 'hotel.number_of_reviews',
    defaultMessage: '##Number of reviews##',
    description: 'Number of reviews label in hotel page',
  },
  fullName: {
    id: 'hotel.full_name',
    defaultMessage: '##Red Planet {hotelName}##',
    description: 'Hotel full name. Do not translate or remove {hotelName}',
  },
  reviewCount: {
    id: 'hotel.review_count',
    defaultMessage:
      '{count, plural, zero {# {reviews}} one {1 {review}} other {# {reviews}}}',
    description: 'Ignore this',
  },
  review: {
    id: 'hotel.review',
    defaultMessage: '##Review##',
    description: 'Singular review',
  },
  reviews: {
    id: 'hotel.reviews',
    defaultMessage: '##Reviews##',
    description: 'Plural review',
  },
  ourGuestsSay: {
    id: 'hotel.our_guest_says',
    defaultMessage: '##Our Guests Say##',
    description: 'Our Guests Say header',
  },
  reviewed: {
    id: 'hotel.reviewed',
    defaultMessage: '##Reviewed##',
    description: 'Reviewed label',
  },
  more: {
    id: 'hotel.more',
    defaultMessage: '##More##',
    description: 'More link',
  },
  nearby: {
    id: 'hotel.nearbies',
    defaultMessage: '##Nearbies##',
    description: 'Nearby header',
  },
  viewMap: {
    id: 'hotel.view_map',
    defaultMessage: '##View Map##',
    description: 'View map button on hotel page',
  },
  noRoomAvailable: {
    id: 'booking.noRoomAvailable',
    defaultMessage: '##Not available##',
    description: 'Label no room available in room type selection page',
  },
  availableFrom: {
    id: 'booking.availableFrom',
    defaultMessage: '##Available From##',
    description:
      'Text to show only when new hotel is opening and not available yet',
  },
});

const tripAdvisorUrl =
  'https://www.tripadvisor.com/img/cdsi/img2/ratings/traveler/';
const tripAdvisorImage = '-50271-5.svg';
let self = null;

class Hotel extends React.Component {
  timeoutPromise = null;

  bindWindowResize = null;

  constructor(props) {
    super(props);
    this.state = {
      hotel: props.hotel,
      category: 'food',
      isMobile: false,
      hasNearby: true,
    };
    self = this;
  }

  componentDidMount() {
    if (process.env.BROWSER) {
      this.bindWindowResize = this.onWindowResize.bind(this);
      window.addEventListener('resize', this.bindWindowResize);
      this.onWindowResize();
    }

    const { user } = this.props;
    let {
      query: { check_in, check_out, adults, children, rooms },
    } = this.props;
    if (!check_in) {
      check_in = moment().format('YYYY-MM-DD');
    }
    if (!check_out) {
      check_out = moment()
        .add(1, 'day')
        .format('YYYY-MM-DD');
    }
    if (!adults) {
      adults = 2;
    }
    if (!children) {
      children = 0;
    }
    if (!rooms) {
      rooms = 1;
    }
    // mp.track('#Hotel Page', { hotel_name: this.props.hotel.helpshift_tag });
    // mp.browse(
    //   this.props.hotel,
    //   this.props.hotel.start_price_remembered,
    //   user,
    //   check_in,
    //   check_out,
    //   adults,
    //   children,
    //   rooms,
    //   this.context.intl.locale,
    // );
  }

  componentWillUnmount() {
    if (this.timeoutPromise) {
      clearTimeout(this.timeoutPromise);
    }
    window.removeEventListener('resize', this.bindWindowResize);
  }

  onWindowResize = () => {
    this.setState({ isMobile: window.innerWidth < maximumMobileWidth });
  };

  onGetHotel = async (checkIn, checkOut) => {
    const hotel = await self.props.getHotel({
      check_in: checkIn.format('YYYY-MM-DD'),
      check_out: checkOut.format('YYYY-MM-DD'),
      code: self.props.query.code,
    });
    self.setState({ hotel });
    let path = `/${self.context.intl.locale}/hotel/${
      hotel.slug_name
    }?check_in=${checkIn.format('YYYY-MM-DD')}&check_out=${checkOut.format(
      'YYYY-MM-DD',
    )}&rooms=1&adults=2&children=0`;
    if (self.props.query.code) {
      path += `&code=${self.props.query.code}`;
    }
    window.history.pushState({ path }, '', path);
  };

  onClickBookNow = () => {
    let {
      query: { rooms, adults, children },
    } = this.props;
    const {
      query: { code },
    } = this.props;
    if (typeof rooms === 'undefined') {
      rooms = 1;
    }
    if (typeof adults === 'undefined') {
      adults = 2;
    }
    if (typeof children === 'undefined') {
      children = 0;
    }
    const checkIn = moment();
    const checkOut = checkIn.clone().add(1, 'day');
    const { hotel } = this.props;
    let search = `&rooms=${rooms}&adults=${adults}&children=${children}`;
    if (code) {
      search += `&code=${code}`;
    }
    history.push({
      pathname: `/${this.context.intl.locale}/booking/room-select/`,
      search: `hotel=${hotel.id}&check_in=${checkIn.format(
        'YYYY-MM-DD',
      )}&check_out=${checkOut.format('YYYY-MM-DD')}${search}`,
    });
  };

  getNearby = async (hotelId, category) => {
    const nearbies = await self.props.getNearby(hotelId, category);
    return nearbies;
  };

  render() {
    const { query, locations } = this.props;
    const { hotel } = this.state;
    const {
      id,
      slug_name,
      name,
      images,
      default_image,
      start_price_remembered,
      currency,
      description,
      opening_date,
      opening_soon,
      check_in,
      user_contents,
      coordinate,
      features,
      usp,
      rooms,
      address,
      phone,
      email,
    } = hotel;
    const { category, isMobile, hasNearby } = this.state;
    let info = null;
    // let price = start_price_remembered;
    const price =
      rooms.length > 0
        ? rooms[0].rate.available_rates[0].selling_rate_member.price_no_tax
        : 0;
    let rate = (
      <FormattedMessage
        {...messages.perNight}
        values={{
          price: (
            <span className={s.price}>
              <CurrencyDisplay
                value={price} // eslint-disable-line camelcase
                currency={currency}
              />
            </span>
          ),
        }}
      />
    );
    if (rooms && rooms.length === 0) {
      if (opening_soon) {
        rate = <div style={{ marginTop: 7 }}>OPENING SOON!</div>;
      } else if (
        opening_date &&
        moment.parseZone(opening_date).isSameOrAfter(moment(check_in))
      ) {
        rate = (
          <div style={{ marginTop: -10, textAlign: 'right' }}>
            <FormattedMessage {...messages.availableFrom} />
            <br />
            {moment.parseZone(opening_date).format('D MMM YYYY')}
          </div>
        );
      } else {
        rate = (
          <div style={{ marginTop: 7 }}>
            <FormattedMessage {...messages.noRoomAvailable} />
          </div>
        );
      }
    }
    let rating = 0;
    let ratingCount = 0;
    let reviewElem = null;
    if (user_contents !== null) {
      const { reviews /* , tags */ } = user_contents;
      if (reviews) {
        info = user_contents.info;
        rating = info.rating;
        ratingCount = info.number_of_reviews;
        const {
          title,
          message,
          rating_image_url,
          review_at,
          review_url,
        } = reviews[Math.floor(Math.random() * (reviews.length - 1))];
        reviewElem = (
          <div className={s.review}>
            <h5>{title}</h5>
            <TruncatableText
              className={s.reviewMessage}
              lines={5}
              text={`"${message}"`}
            />
            <div className={s.rating}>
              <img src={rating_image_url} alt="rating" />
              <span className={s.reviewed}>
                <FormattedMessage {...messages.reviewed} />{' '}
                {moment(review_at).from(moment())}
              </span>
              <a
                href={review_url}
                hrefLang={this.context.intl.locale}
                target="__blank"
              >
                <FormattedMessage {...messages.more} />
              </a>
            </div>
          </div>
        );
      }
    }
    const fullName = this.context.intl.formatMessage(messages.fullName, {
      hotelName: hotel.name,
    });
    let country = null;
    let city = null;
    locations.forEach(c => {
      c.children.forEach(ct => {
        ct.children.forEach(area => {
          if (area.id === hotel.location.id) {
            country = c;
            city = ct;
          }
        });
      });
    });
    const addr = address.replace(/\n/gm, '');
    const desc = description.replace(/\n/gm, '');
    return (
      <div className={cx(s.root, s[this.context.intl.locale])}>
        {country && city && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: `{ "@context" : "http://schema.org", "@type" : "WebSite", "name" : "${fullName}", "url" : "https://www.redplanethotels.com/hotel/${slug_name}", "publisher" : {"@type" : "Hotel", "name" : "${fullName}", "@id" : "https://www.redplanethotels.com/hotel/${slug_name}", "logo" : "https://cdn.redplanethotels.com/images/icon-76@2x.webp", "url" : "https://www.redplanethotels.com/hotel/${slug_name}", "image" : "${default_image}", "brand" : {"@type" : "Brand", "name" : "Red Planet Hotels", "url" : "https://www.redplanethotels.com/", "logo" : "https://cdn.redplanethotels.com/images/icon-76@2x.webp"}, "aggregateRating" : {"@type" : "AggregateRating", "ratingValue" : ${rating}, "reviewCount" : ${ratingCount}}, "description" : "${desc}", "telephone" : "${phone}", "parentOrganization": {"@type": "Corporation", "url": "https://www.redplanethotels.com/", "name" : "Red Planet Hotels", "logo" : "https://cdn.redplanethotels.com/images/icon-76@2x.webp", "id" : "https://www.redplanethotels.com/"}, "contactPoint" : [{"@type" : "ContactPoint", "contactType" : "Customer Service", "telephone" : "${phone}", "email" : "${email}"} ], "address" : {"@type" : "PostalAddress", "streetAddress" : "${addr}", "addressLocality" : "${city.name}", "addressCountry" : "${country.name}"}, "potentialAction":{"@type":"ReserveAction", "target":{"@type":"EntryPoint", "inLanguage": "${this.context.intl.locale}", "urlTemplate":"https://www.redplanethotels.com/hotel/${slug_name}", "actionPlatform":["http://schema.org/DesktopWebPlatform", "http://schema.org/IOSPlatform", "http://schema.org/AndroidPlatform"] }, "result":{"@type":"LodgingReservation", "name":"Book Room"} } }}`,
            }}
          />
        )}
        <div className={s.hero}>
          <div
            className={s.heroImage}
            style={{ backgroundImage: `url(${default_image})` }}
          />
          <div className={s.nameOverlay} />
          <div className={s.hotelFullName}>
            <div className={s.content}>
              <BreadCrumb
                hotel={this.props.hotel}
                locations={locations}
                query={query}
              />
              <div className={s.halfOfContent}>
                <HotelNameOverlay hotel={this.props.hotel} />
                <HotelImagesGallery images={images} />
              </div>
            </div>
          </div>
        </div>
        <div className={s.priceBox}>
          <div className={s.fluid}>
            <div className={s.body}>
              <div className={s.row}>
                <div className={s.col12}>
                  <div className={s.pricePerNight}>{rate}</div>
                  {features && (
                    <div className={s.features}>
                      <span className={s.free}>FREE</span>
                      {features.map((feature, index) => (
                        <span key={feature.code}>
                          {index > 0 && <i className={s.ruler} />}
                          <img
                            src={featureImages[feature.code].normal}
                            srcSet={`${featureImages[feature.code].add2x} 2x`}
                            alt={feature.code}
                          />
                        </span>
                      ))}
                    </div>
                  )}
                  <div className={s.usp}>
                    {usp &&
                      usp.map((feature, index) => (
                        <div key={`${feature.icon}${index}`}>
                          {index > 0 && <i className={s.ruler} />}
                          <CDNImage
                            path="assets/photos/usp/"
                            image={{
                              normal: `${feature.icon}.webp`,
                              add2x: `${feature.icon}@2x.webp`,
                            }}
                          />
                          <div className={s.description}>
                            {feature.description.split('\n').map(line => (
                              <div key={line.trim()}>{line.trim()}</div>
                            ))}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <BookingEngine
            hotel={this.state.hotel}
            query={query}
            onDateChange={this.onGetHotel}
          />
        </div>
        <div className={s.container}>
          <div className={s.row}>
            <div className={s.col6}>
              <div className={s.flexBox}>
                <div className={s.flexTop}>
                  <div className={s.hotelDetail}>
                    <h2>
                      <FormattedMessage
                        {...messages.fullName}
                        values={{
                          hotelName: (
                            <span className={s.noHighlight}>{name}</span>
                          ),
                        }}
                      />
                    </h2>
                    <div className={s.hotelAddress}>
                      <div className={s.image}>
                        <img
                          src={iconPin}
                          srcSet={`${iconPinAdd2x} 2x`}
                          alt="icon pin"
                        />
                      </div>
                      <div className={s.content}>
                        <a
                          href={`https://www.google.com/maps/place/${coordinate}`}
                          hrefLang={this.context.intl.locale}
                          target="__blank"
                        >
                          <p>{address.replace(/\n/g, ', ')}</p>
                        </a>
                      </div>
                    </div>
                    <div className={s.hotelAddress}>
                      <div className={s.image}>
                        <img
                          src={iconPhone}
                          srcSet={`${iconPhoneAdd2x} 2x`}
                          alt="icon phone"
                        />
                      </div>
                      <div className={s.content}>
                        <a
                          href={`tel:${phone}`}
                          hrefLang={this.context.intl.locale}
                        >
                          {phone}
                        </a>
                      </div>
                    </div>
                  </div>
                  {info !== null && (
                    <div className={s.hotelRate}>
                      <div className={s.rating}>
                        <img
                          src={`${tripAdvisorUrl}${user_contents.info.rating.toPrecision(
                            2,
                          )}${tripAdvisorImage}`}
                          alt="TripAdvisor rating"
                        />
                        <span className={s.ratingText}>
                          <FormattedMessage
                            {...messages.reviewCount}
                            values={{
                              count: info.total_reviews,
                              review: <FormattedMessage {...messages.review} />,
                              reviews: (
                                <FormattedMessage {...messages.reviews} />
                              ),
                            }}
                          />
                        </span>
                      </div>
                    </div>
                  )}
                  <TruncatableText
                    className={s.hotelDescription}
                    text={description}
                    lines={3}
                  />
                </div>
                <div className={s.flexMiddle}>
                  {reviewElem && (
                    <div>
                      <div className={s.line} />
                      <h3>
                        <FormattedMessage {...messages.ourGuestsSay} />
                      </h3>
                      <div className={s.row}>
                        <div className={s.col12}>{reviewElem}</div>
                      </div>
                    </div>
                  )}
                  <div style={{ display: isMobile ? 'block' : 'none' }}>
                    <LeafletMobile
                      hotels={[this.props.hotel]}
                      hoveringHotel={this.props.hotel}
                    />
                    <a
                      className={s.mapViewBtn}
                      href={`https://www.google.com/maps/place/${coordinate}`}
                      hrefLang={this.context.intl.locale}
                    >
                      <FormattedMessage {...messages.viewMap} />
                    </a>                  </div>
                </div>
                {hasNearby && (
                  <div className={s.flexBottom}>
                    <div className={s.line} />
                    <h3>
                      <FormattedMessage {...messages.nearby} />
                    </h3>
                    <div>
                      <NearbyMenus
                        onSelectedMenu={cat => {
                          this.setState({ category: cat });
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={s.col6}>
              <div className={cx(s.map, !reviewElem && s.noReview)}>
                <Leaflet
                  hotels={[this.props.hotel]}
                  hoveringHotel={this.props.hotel}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={s.nearby}>
          <div className={s.fluid}>
            <div className={s.body}>
              <div className={s.row}>
                <div className={s.col12}>
                  <Nearby
                    getNearby={this.getNearby}
                    hotelId={id}
                    category={category}
                    nearbyPerPage={isMobile ? 3 : 7}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Hotel.propTypes = {
  hotel: HotelType.shape().isRequired,
  user: UserType.shape().isRequired,
  locations: PropTypes.array,
  getHotel: PropTypes.func.isRequired,
  getNearby: PropTypes.func.isRequired,
  query: PropTypes.shape({
    check_in: PropTypes.string,
    check_out: PropTypes.string,
    rooms: PropTypes.string,
    adults: PropTypes.string,
    children: PropTypes.string,
    code: PropTypes.string,
  }),
};

Hotel.contextTypes = {
  intl: intlShape,
};

Hotel.defaultProps = {
  locations: [],
  query: {
    check_in: moment().format('YYYY-MM-DD'),
    check_out: moment()
      .add(1, 'd')
      .format('YYYY-MM-DD'),
    rooms: 1,
    adults: 2,
    children: 0,
    code: '',
  },
};

const mapState = state => ({
  user: state.user,
});

export default connect(mapState)(withStyles(s)(Hotel));
